function ShopifyService(ApiService) {
  'ngInject';
  const service = {};

  service.saveFile = function(shopifyfileForm, orgId, callbackFunc) {
    ApiService.saveFile(`/organizations/${orgId}/shopify_payments/import.json`, shopifyfileForm, callbackFunc);
  };

  service.getshopifyInvoices = function(orgId, url, pageNumber, size, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.getInvoice = function(orgId, invoiceId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/shopify_invoices/${invoiceId}.json`, callbackFunc);
  };

  service.reportExists = function(orgId,date,callbackFunc){
    ApiService.get(`/organizations/${orgId}/shopify_invoices/validate_date.json?date=${date}`, callbackFunc);
  };

  service.tryNow = function(orgId, date, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/shopify_invoices/try_now.json?date=${date}`, callbackFunc);
  };

  return service;
}

export default{
  name: 'ShopifyService',
  fn: ShopifyService
};
